import { dashboardConstants } from '../../constants';

function setDashboardDataToStore(payload) {
  return { type: dashboardConstants.DASHBOARDDATA, payload };
}

function setLocationDataToStore(payload) {
  return { type: dashboardConstants.LOCATIONDATA, payload };
}

function setCreditsAvailableToStore(payload) {
  return { type: dashboardConstants.CREDITS, payload };
}

function setRedirectPathToStore(payload) {
  return { type: dashboardConstants.REDIRECTPATH, payload };
}

function setScrolledHeightOfDocumentToStore(payload) {
  return { type: dashboardConstants.SCROLLEDHEIGHT, payload };
}

function setRestrictionModalToStore(payload) {
  return { type: dashboardConstants.RESTRICT, payload };
}

function setTokenToStore(payload) {
  console.log('firebase token getting saved');
  return { type: dashboardConstants.FIREBASETOKEN, payload };
}

function setSubscribedTopicsArrayToStore(payload) {
  return { type: dashboardConstants.TOPICSARRAY, payload };
}

function clearDashboardDataFromStore() {
  return { type: dashboardConstants.CLEARDASHBOARDDATA };
}

function setNavbarDataToStore(payload) {
  return { type: dashboardConstants.NAVBARDATA, payload };
}

function setActiveTagsToStore(payload) {
  return { type: dashboardConstants.ACTIVETAGS, payload };
}

export const dashboardActions = {
  setDashboardDataToStore,
  setLocationDataToStore,
  clearDashboardDataFromStore,
  setRedirectPathToStore,
  setTokenToStore,
  setScrolledHeightOfDocumentToStore,
  setSubscribedTopicsArrayToStore,
  setNavbarDataToStore,
  setCreditsAvailableToStore,
  setRestrictionModalToStore,
  setActiveTagsToStore,
};
